module.exports = __webpack_public_path__ + "img/company.6e315ac8.png";